import React from 'react';
import {IconPhone, IconMail} from '@tabler/icons-react';

const SignupServiceInfo = () => {
    const iconStyle = {
        marginRight: '.5rem',
    };

    return (
        <>
            <h2>Fragen zum Bewerbungsprozess?</h2>
            <p>
                Kontaktieren Sie uns <strong>werktags von 9:00 bis 17:00 Uhr</strong> via
                Telefon oder E-Mail.
            </p>
            <div>
                <a
                    className="anl_signup--telephone-number d-block"
                    href="tel:+4922167774683"
                >
                    <IconPhone
                        style={iconStyle}
                        size={20}
                    />
                    <span className="visually-hidden">
                        Erreichbar per Telefon mit der Nummer:
                    </span>
                    0221 677 746 83
                </a>
                <a
                    className="anl_signup--email d-block mt-2"
                    href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || "hilfe@projektbigfoot.de"}`}
                >
                    <IconMail
                        style={iconStyle}
                        size={20}
                    />
                    <span className="visually-hidden">
                        Oder per E-Mail mit der Adresse:
                    </span>
                    {`${process.env.REACT_APP_SUPPORT_EMAIL || "hilfe@projektbigfoot.de"}`}
                </a>
            </div>
        </>
    );
};

export default SignupServiceInfo;